import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { Button } from "../../../Button";
import { Form } from "../../../Form";
import { BillTypeBodyContainer, BillInvoiceContainer } from "../../styled";
import { batchInovice } from "../../../../services";
import { numberWithCommas } from "../../../../utils";

export const BillTypeBody = ({ closeModal, bill }) => {
  const { register, control, errors, watch, handleSubmit } = useForm();
  const values = watch();
  const [invoice, setInvoice] = useState();
  const isBatch = values ? values.batch : false;
  const [isLoading, setIsLoading] = useState();

  async function onSubmit(data) {
    if (invoice) {
      window.location.href = invoice.url;
    } else {
      try {
        setIsLoading(true);
        const response = await batchInovice({
          ...data,
          productId: bill.entityId,
        });
        if (response.data.type === "DIRECT") {
          toast("با موفقیت پرداخت شد", { type: "success", toastId: "success" });
          closeModal();
        } else {
          if (isBatch) {
            window.location.href = response.data.url;
          } else {
            setInvoice(response.data);
          }
        }
      } catch (error) {
        toast("درخواست شما امکان پذیر نمی باشد", {
          type: "error",
          toastId: "error",
        });
      } finally {
        setIsLoading(false);
      }
    }
  }

  return (
    <BillTypeBodyContainer isloading={isLoading}>
      {invoice ? (
        <BillInvoiceContainer>
          آیا مایل به پرداخت مبلغ{" "}
          <span>{numberWithCommas(invoice.amount / 10)} تومان</span> برای{" "}
          <span>{bill.name}</span> هستید؟
        </BillInvoiceContainer>
      ) : (
        <>
          <h1>{bill.name}</h1>
          <Form
            control={control}
            errors={errors}
            register={register}
            values={values}
            fields={bill.fields && JSON.parse(bill.fields)}
          />
        </>
      )}

      <div className="buttons-container">
        <Button onClick={closeModal} color="red">
          لغو عملیات
        </Button>
        {invoice ? (
          <Button
            onClick={() => {
              window.location.href = invoice.url;
            }}
            color="green"
          >
            بله پرداخت شود
          </Button>
        ) : (
          <Button onClick={handleSubmit(onSubmit)} color="green">
            {isBatch ? "پرداخت برنامه ریزی شود" : "استعلام قبض"}
          </Button>
        )}
      </div>
    </BillTypeBodyContainer>
  );
};
